import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ic_search from "../assets/images/icons/search.svg";
import user from "../assets/images/icons/user.svg";
import { Breadcrumb, LanguageSwitcher, ProfileAvatar } from "../components";
import { useGetPersonalInfo } from "../hooks";
import { RootState } from "../redux/store";
import { formatDoctorName } from "../utils/utils";
import Notifications from "./Notifications";

const Navbar: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const UserInfo = useSelector((state: RootState) => state.registration);
  const { data } = useGetPersonalInfo();
  const personalData = data?.Data;
  return (
    <div className="flex flex-col-reverse items-start justify-between max-md:mx-1 max-md:flex-wrap-reverse md:flex-row md:items-center md:gap-4">
      <div className="flex flex-col items-start justify-start gap-0.5 max-md:w-full max-md:py-3">
        <div className="self-stretch font-bold">
          <Breadcrumb separator="»" />
        </div>
      </div>
      <div className="box flex h-16 flex-nowrap items-center gap-6 !ps-3 max-md:w-full max-xs:gap-1">
        <div
          className="main_warper cursor-pointer"
          onClick={() => navigate("/search")}
        >
          <img src={ic_search} alt="search" className="h-5 w-5" />
          <span className="text-sm">{t("search")}</span>
        </div>
        <Notifications />
        <LanguageSwitcher />

        <div
          className="flex cursor-pointer flex-nowrap gap-2"
          onClick={() => navigate("/profile")}
        >
          <ProfileAvatar
            Id={personalData?.Id}
            FullName={personalData?.FullName}
            alt="profile"
            size={"small"}
            imageToLoad={user}
            src={personalData?.Image}
            className="h-10 w-10 flex-none rounded-full object-cover"
            height="2.5rem"
            width="2.5rem"
          />
          <div>
            <p className="line-clamp-1 whitespace-nowrap text-sm font-bold text-primary-text max-xs:w-28 md:w-32 lg:w-40">
              {formatDoctorName(
                personalData?.FullName,
                personalData?.FullNameAr,
                personalData?.FullNameEn,
              )}
            </p>
            <div
              dir="ltr"
              className="text-xs font-normal text-body-text rtl:text-end"
            >
              {UserInfo.userDetails.Country?.Code}-
              {UserInfo.userDetails.PhoneNumber}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
